import useReveal from "@/lib/useReveal";

export const SectionHeader = ({ eyebrow, title, subtitle, testId }) => {
  const ref = useReveal();
  return (
    <div ref={ref} className="reveal text-center max-w-3xl mx-auto mb-16 md:mb-24">
      {eyebrow && (
        <p
          data-testid={testId ? `${testId}-eyebrow` : undefined}
          className="text-xs uppercase tracking-[0.35em] text-[#68919B] mb-6 font-medium"
        >
          {eyebrow}
        </p>
      )}
      <h2
        data-testid={testId ? `${testId}-title` : undefined}
        className="font-serif text-4xl sm:text-5xl md:text-6xl text-[#3D5E68] font-light tracking-tight leading-[1.1]"
      >
        {title}
      </h2>
      <div className="flex items-center justify-center mt-8">
        <span className="ornament" />
      </div>
      {subtitle && (
        <p className="mt-8 text-base md:text-lg text-[#5A7682] font-light leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};
